// extracted by mini-css-extract-plugin
export default {"wrapper":"AICompanyIdeasTooltip_wrapper__8Uv94"};